import { percent, px, rem } from 'csx';
import { style } from 'typestyle';
import { NestedCSSProperties } from 'typestyle/lib/types';
import { colorGreyAccent } from '../../theme/color';
import { shadowElevation2 } from '../../theme/shadow';
import { centerCenter } from 'csstips';

export const CollapsibleStateIndicatorStyle: NestedCSSProperties = {
  position: 'relative',
  $nest: {
    '&::after': {},
    '[open] &::after': {
      transform: 'rotate(180deg)',
      boxShadow: '0px -2px 4px 1px rgba(0,0,0,0.3)',
    },
  },
};

export const CollapsibleStateIndicatorWrapperStyle: NestedCSSProperties = {
  ...shadowElevation2,
  width: px(32),
  height: px(32),
  borderRadius: rem(1),
  lineHeight: px(35),
  textAlign: 'center',
  fontSize: px(11),
  backgroundColor: colorGreyAccent.toHexString(),
  $nest: {
    '.open > .summary & span': {
      transform: 'rotate(180deg)',
    },
  },
};

export const CollapsibleStateIndicatorButtonStyle: NestedCSSProperties = {
  ...centerCenter,
  transition: '0.25s transform ease-in-out',
  height: '100%',
};

export const CollabsibleContainerStyle: NestedCSSProperties = {
  boxShadow: '0 6px 6px 1px rgba(0,0,0,0.05)',
  border: '1px solid',
  borderColor: colorGreyAccent.toHexString(),
  borderRadius: px(8),
};

export const CollabsibleSummaryStyle: NestedCSSProperties = {
  padding: px(15),
  cursor: 'pointer',
};

export const CollabsibleSummaryLabelStyle: NestedCSSProperties = {
  width: percent(100),
  fontWeight: 600,
  textAlign: 'center',
  fontSize: px(12),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  $nest: {
    '& > p': {
      flexGrow: 1,
      margin: 0,
    },
  },
};

export default {
  stateIndicator: style(CollapsibleStateIndicatorStyle),
  stateIndicatorWrapper: style(CollapsibleStateIndicatorWrapperStyle),
  stateIndicatorButton: style(CollapsibleStateIndicatorButtonStyle),
  container: style(CollabsibleContainerStyle),
  summary: style(CollabsibleSummaryStyle),
  summaryLabel: style(CollabsibleSummaryLabelStyle),
};
